import * as React from "react";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
import LazyLoad from "react-lazyload";
import { liveAnnounce } from "uitk-react-utils";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { useLocalization } from "@shared-ui/localization-context";

const localizeSearchMonth = (month: string) => {
  const { formatText } = useLocalization();

  return formatText("tripCost.popover.searchMonth", month) || `Search ${month}`;
};

export interface PopoverProps {
  containerWidth: number;
  x: number;
  y: number;
  title: string;
  linkText: string;
  linkAction: () => any;
  isOpen?: boolean;
}

type EventClick = React.MouseEvent<HTMLDivElement, MouseEvent>;

export const Popover = (props: PopoverProps) => {
  const elemRef = React.useRef(null);
  const element = (elemRef && elemRef.current) || { clientWidth: 90 };
  const preventClose = React.useCallback((e: EventClick) => e.stopPropagation(), []);
  const linkAction = React.useCallback(
    (e: EventClick) => {
      e.preventDefault();
      props.linkAction();
    },
    [props.linkAction]
  );

  const containerWidth = props.containerWidth || 0;

  const positionX =
    props.x + element.clientWidth / 2 > containerWidth
      ? containerWidth - element.clientWidth
      : props.x - element.clientWidth / 2;

  const style = React.useMemo(() => ({ transform: `translate(${positionX < 0 ? 17 : positionX}px, 50%` }), [
    props.y,
    props.x,
  ]);

  React.useEffect(() => {
    if (props.isOpen) {
      liveAnnounce(`${props.title}: ${props.linkText}`);
    }
  }, [props.title, props.linkText, props.isOpen]);

  return props.isOpen ? (
    <LazyLoad>
      <div className="zoomAnimation" onClick={preventClose}>
        <UitkCard className="Popover elevation">
          <div ref={elemRef} className="Popover uitk-card uitk-card-roundcorner-all elevation" style={style}>
            <UitkCardContentSection>
              <UitkText size={300} weight="bold" align="center">
                {props.title}
              </UitkText>
              <UitkLink align="center">
                <TrackedLink moduleName="tripCostEstimator" rfrr="link-popover" href="#" onClick={linkAction}>
                  {localizeSearchMonth(props.linkText)}
                </TrackedLink>
              </UitkLink>
            </UitkCardContentSection>
          </div>
        </UitkCard>
      </div>
    </LazyLoad>
  ) : null;
};

export default Popover;
